export default __webpack_public_path__ + "68578a4d0eb3e27ff5c3bf1433be5873.svg";